"use strict";

/**
 * Proxy for web-sdk's request.
 *
 * - Sets default values for flow.js
 * - Adds authenticated type request which adds Authorization: Session header
 * - Adds anonymous request type which is a passthrough to web-sdk
 */
var webSdkRequest = require('@flowio/web-sdk').request;

var assign = require('lodash/assign');

var getSessionId = require('./getSessionId');

var NETWORK_ERROR = 'A network error has occurred while processing your request. Please try again.';
/**
 * @description Shim method to support newer version of @flowio/web-sdk only returning promises now.
 * When this lib is re-written, this can all be pulled out.
 */

function mapWebsdkPromiseToCallback(
/** @type {Promise<import('@flowio/web-sdk').NetworkResponse>} */
webSdkPromise, callback) {
  webSdkPromise.then(function (response) {
    if (response.ok) {
      callback(response.status, response.response);
    } else if (response.error) {
      callback(response.status, {
        error: response.error
      });
    } else {
      callback(response.status, {
        error: {
          messages: [NETWORK_ERROR]
        }
      });
    }
  });
}

var defaultOptions = {
  jsonp: false,
  failOnMissingCredentials: false
};

function getOptions(opts) {
  return assign({}, defaultOptions, opts);
}

function anonymous(options, callback) {
  mapWebsdkPromiseToCallback(webSdkRequest(getOptions(options)), callback);
}

function authenticated(options, callback) {
  var finalOptions = getOptions(options);
  var sessionId = getSessionId();
  var updatedHeaders = assign({}, options.headers, {
    Authorization: "Session ".concat(getSessionId())
  });

  if (finalOptions.failOnMissingCredentials && !sessionId) {
    callback(500, new Error('Id on session was not defined.'));
    return;
  }

  mapWebsdkPromiseToCallback(webSdkRequest(assign(getOptions(options), {
    headers: updatedHeaders
  })), callback);
}

module.exports = {
  authenticated: authenticated,
  anonymous: anonymous
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/request/lib/index.js
// module id = 15
// module chunks = 0 1